/* eslint-disable */
// Reglas de clima de obra. ESTE ARCHIVO ES EL MISMO (copia idéntica) en tres lugares:
//   - lisual-admin-backend  src/clima/services/reglasClima.js   (vista previa de avisos, tests)
//   - lisual-dashboard      my-app/src/camera/components/weather/clima/reglasClima.js  (Obra › Clima)
//   - motor del Editor      clima-patch/editor/reglasClima.js   (avisos por WhatsApp / mail)
// Si se cambia una regla, se copia a los tres (los tests del backend cubren la lógica).
//
// Sin dependencias, sin red y sin fechas del sistema: todo entra por parámetro (ahora, pronóstico, umbrales).
// Los textos son plantillas fijas en castellano simple (cero IA, cero costo).
//
// Datos: Open-Meteo (gratis, sin clave). Las horas vienen en hora local de la obra ("YYYY-MM-DDTHH:00").
'use strict';

// ───────────────────────────────────────────── umbrales (los puede cambiar el cliente)
const UMBRALES_DEFAULT = {
  jornadaDesde: 8, // h
  jornadaHasta: 18, // h (no incluida)
  diasLaborales: [1, 2, 3, 4, 5], // ISO: 1 = lunes … 7 = domingo
  lluviaNoApto: 5, // mm en el horario de trabajo
  lluviaCuidado: 1, // mm en el horario de trabajo
  probCuidado: 60, // % de probabilidad de lluvia
  rafagaNoApto: 60, // km/h
  rafagaCuidado: 40, // km/h
  calorNoApto: 36, // °C
  calorCuidado: 32,
  frioNoApto: 0,
  frioCuidado: 5,
  // tareas
  gruaRafaga: 40, // izaje: ráfaga máxima permitida
  hormigonTmin: 5,
  hormigonTmax: 32,
  hormigonRafaga: 40,
  ventanaAntes: 24, // h sin lluvia antes de hormigonar / impermeabilizar
  ventanaDespues: 48, // h sin lluvia después de hormigonar
};

const LIMITES = {
  jornadaDesde: [0, 23], jornadaHasta: [1, 24], lluviaNoApto: [0.5, 100], lluviaCuidado: [0.1, 50], probCuidado: [10, 100],
  rafagaNoApto: [10, 150], rafagaCuidado: [5, 150], calorNoApto: [20, 50], calorCuidado: [15, 50], frioNoApto: [-20, 15],
  frioCuidado: [-20, 20], gruaRafaga: [10, 120], hormigonTmin: [-5, 20], hormigonTmax: [20, 45], hormigonRafaga: [10, 120],
  ventanaAntes: [0, 72], ventanaDespues: [0, 96],
};

/** Mezcla lo que manda el cliente con los defaults, acotando cada número a un rango razonable. */
function sanearUmbrales(input) {
  const out = Object.assign({}, UMBRALES_DEFAULT);
  const x = input && typeof input === 'object' ? input : {};
  Object.keys(LIMITES).forEach((k) => {
    const n = Number(x[k]);
    if (x[k] !== undefined && x[k] !== null && x[k] !== '' && Number.isFinite(n)) out[k] = Math.min(LIMITES[k][1], Math.max(LIMITES[k][0], Math.round(n * 10) / 10));
  });
  if (Array.isArray(x.diasLaborales)) {
    const d = Array.from(new Set(x.diasLaborales.map(Number).filter((v) => v >= 1 && v <= 7))).sort();
    if (d.length) out.diasLaborales = d;
  }
  out.jornadaDesde = Math.round(out.jornadaDesde);
  out.jornadaHasta = Math.round(out.jornadaHasta);
  if (out.jornadaHasta <= out.jornadaDesde) out.jornadaHasta = Math.min(24, out.jornadaDesde + 1);
  if (out.lluviaCuidado > out.lluviaNoApto) out.lluviaCuidado = out.lluviaNoApto;
  if (out.rafagaCuidado > out.rafagaNoApto) out.rafagaCuidado = out.rafagaNoApto;
  if (out.calorCuidado > out.calorNoApto) out.calorCuidado = out.calorNoApto;
  if (out.frioCuidado < out.frioNoApto) out.frioCuidado = out.frioNoApto;
  if (out.hormigonTmax <= out.hormigonTmin) out.hormigonTmax = out.hormigonTmin + 10;
  return out;
}

// ───────────────────────────────────────────── utilidades de fecha (sin zona: strings locales)
const pad = (n) => String(n).padStart(2, '0');
const addDias = (f, n) => new Date(Date.parse(f + 'T12:00:00Z') + n * 864e5).toISOString().slice(0, 10);
const diaIso = (f) => { const d = new Date(f + 'T12:00:00Z').getUTCDay(); return d === 0 ? 7 : d; }; // 1 = lunes
const horaDe = (t) => Number(String(t).slice(11, 13));
const fechaDe = (t) => String(t).slice(0, 10);
/** "Ahora" en hora local de la obra ("YYYY-MM-DDTHH:MM") a partir de ms UTC y el desfase de Open-Meteo (segundos). */
const localDe = (ms, offsetSeg) => new Date(ms + (offsetSeg || 0) * 1000).toISOString().slice(0, 16);
const DIAS_CORTO = ['', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb', 'dom'];
const DIAS_LARGO = ['', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const fechaLarga = (f) => `${DIAS_LARGO[diaIso(f)]} ${Number(f.slice(8, 10))} de ${MESES[Number(f.slice(5, 7)) - 1]}`;
const mayuscula = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
const fechaCorta = (f) => `${DIAS_CORTO[diaIso(f)]} ${Number(f.slice(8, 10))}/${Number(f.slice(5, 7))}`;
const num = (v, d = 0) => (v == null || !Number.isFinite(v) ? '—' : (Math.round(v * 10 ** d) / 10 ** d).toString().replace('.', ','));
const rango = (hs) => {
  if (!hs.length) return '';
  const a = horaDe(hs[0].t), b = horaDe(hs[hs.length - 1].t) + 1;
  return b - a <= 1 ? `a las ${a} h` : `entre las ${a} y las ${b} h`;
};

// ───────────────────────────────────────────── normalización de Open-Meteo
/**
 * Convierte la respuesta de Open-Meteo (forecast o archive, con timezone=auto) en
 * { offset, horas: [{t, fecha, h, temp, sens, mm, prob, code, viento, rafaga, dir, hum, rocio, vis, uv, dia}],
 *   dias: [{fecha, code, tmax, tmin, mm, prob, rafaga, viento, horasLluvia, uv, amanecer, atardecer}], actual, m15 }
 */
function desdeOpenMeteo(j) {
  const H = (j && j.hourly) || {}, D = (j && j.daily) || {};
  const g = (o, k, i) => (o[k] && o[k][i] != null ? o[k][i] : null);
  const horas = (H.time || []).map((t, i) => ({
    t, fecha: fechaDe(t), h: horaDe(t),
    temp: g(H, 'temperature_2m', i), sens: g(H, 'apparent_temperature', i), mm: g(H, 'precipitation', i) || 0,
    prob: g(H, 'precipitation_probability', i), code: g(H, 'weather_code', i), viento: g(H, 'wind_speed_10m', i),
    rafaga: g(H, 'wind_gusts_10m', i), dir: g(H, 'wind_direction_10m', i), hum: g(H, 'relative_humidity_2m', i),
    rocio: g(H, 'dew_point_2m', i), vis: g(H, 'visibility', i), uv: g(H, 'uv_index', i), dia: g(H, 'is_day', i), pres: g(H, 'pressure_msl', i),
  })).filter((x) => x.temp != null);
  const dias = (D.time || []).map((f, i) => ({
    fecha: f, code: g(D, 'weather_code', i), tmax: g(D, 'temperature_2m_max', i), tmin: g(D, 'temperature_2m_min', i),
    mm: g(D, 'precipitation_sum', i) || 0, prob: g(D, 'precipitation_probability_max', i), rafaga: g(D, 'wind_gusts_10m_max', i),
    viento: g(D, 'wind_speed_10m_max', i), horasLluvia: g(D, 'precipitation_hours', i), uv: g(D, 'uv_index_max', i),
    amanecer: g(D, 'sunrise', i), atardecer: g(D, 'sunset', i), dir: g(D, 'wind_direction_10m_dominant', i),
  })).filter((x) => x.tmax != null || x.mm != null);
  const m15 = j && j.minutely_15 ? (j.minutely_15.time || []).map((t, i) => ({ t, mm: (j.minutely_15.precipitation || [])[i] || 0 })) : [];
  return { offset: (j && j.utc_offset_seconds) || 0, horas, dias, actual: (j && j.current) || null, m15 };
}

/** Índice por fecha para no recorrer todo cada vez. */
function indexar(p) {
  const porFecha = new Map();
  (p.horas || []).forEach((x) => { if (!porFecha.has(x.fecha)) porFecha.set(x.fecha, []); porFecha.get(x.fecha).push(x); });
  const dias = new Map((p.dias || []).map((d) => [d.fecha, d]));
  return { ...p, porFecha, diasMap: dias };
}

/** Horas entre dos instantes locales [desde, hasta) ("YYYY-MM-DDTHH:00"). */
function horasEntre(ix, desde, hasta) {
  return (ix.horas || []).filter((x) => x.t >= desde && x.t < hasta);
}
const tLocal = (f, h) => (h >= 24 ? `${addDias(f, 1)}T${pad(h - 24)}:00` : h < 0 ? `${addDias(f, -1)}T${pad(24 + h)}:00` : `${f}T${pad(h)}:00`);
const suma = (hs, k = 'mm') => hs.reduce((a, x) => a + (x[k] || 0), 0);
const maxDe = (hs, k) => hs.reduce((a, x) => (x[k] != null && (a == null || x[k] > a) ? x[k] : a), null);
const minDe = (hs, k) => hs.reduce((a, x) => (x[k] != null && (a == null || x[k] < a) ? x[k] : a), null);

// ───────────────────────────────────────────── tipo de tiempo (mismos nombres que el Dashboard IA)
function tipoTiempo(code, mm, noche) {
  if (code == null) return null;
  if (code >= 95) return 'tormenta';
  if ((code >= 71 && code <= 77) || code === 85 || code === 86) return 'nieve';
  if ((code >= 61 && code <= 67) || code === 82 || (code >= 80 && mm >= 5)) return 'lluvia';
  if ((code >= 51 && code <= 57) || (code >= 80 && code <= 81)) return 'chaparron';
  if (code === 45 || code === 48) return 'niebla';
  if (code === 3) return 'nublado';
  if (code === 2) return 'parcial';
  return noche ? 'noche' : 'sol';
}
const TIEMPO_TXT = { sol: 'Soleado', noche: 'Despejado', parcial: 'Parcialmente nublado', nublado: 'Nublado', niebla: 'Niebla', chaparron: 'Lloviznas', lluvia: 'Lluvia', tormenta: 'Tormenta', nieve: 'Nieve' };

const PUNTOS_CARD = ['N', 'NE', 'E', 'SE', 'S', 'SO', 'O', 'NO'];
const direccionTxt = (deg) => (deg == null ? '' : PUNTOS_CARD[Math.round(((deg % 360) + 360) % 360 / 45) % 8]);

// ───────────────────────────────────────────── semáforo de trabajo por día
const ORDEN = { apto: 0, cuidado: 1, no: 2 };
const ESTADO_TXT = { apto: 'Apto', cuidado: 'Con cuidado', no: 'No apto' };

/**
 * Evalúa un día de obra. Con horas (pronóstico o archivo horario) mira solo el horario de trabajo;
 * sin horas usa el dato diario (climatología) con un criterio equivalente.
 * Devuelve { fecha, estado: 'apto'|'cuidado'|'no', motivos: [{tipo, estado, texto}], laborable, datos, resumen }.
 */
function evaluarDia(ix, fecha, U) {
  U = U || UMBRALES_DEFAULT;
  const todas = (ix.porFecha && ix.porFecha.get(fecha)) || [];
  const hs = todas.filter((x) => x.h >= U.jornadaDesde && x.h < U.jornadaHasta);
  const d = ix.diasMap && ix.diasMap.get(fecha);
  const motivos = [];
  const add = (tipo, estado, texto) => motivos.push({ tipo, estado, texto });
  let datos;
  if (hs.length >= 3) {
    const mmJ = suma(hs), mmDia = suma(todas);
    const lluviosas = hs.filter((x) => x.mm >= 0.2);
    const tormenta = hs.filter((x) => x.code >= 95);
    const probMax = maxDe(hs, 'prob');
    const raf = maxDe(hs, 'rafaga');
    const tmax = maxDe(hs, 'temp'), tmin = minDe(hs, 'temp');
    const horaRaf = raf != null ? hs.find((x) => x.rafaga === raf) : null;
    datos = { mmJ, mmDia, probMax, rafaga: raf, tmax, tmin, horas: hs.length, tmaxDia: maxDe(todas, 'temp'), tminDia: minDe(todas, 'temp'), code: d ? d.code : maxDe(hs, 'code') };
    if (tormenta.length) add('tormenta', 'no', `Tormenta eléctrica ${rango(tormenta)}`);
    if (mmJ >= U.lluviaNoApto) add('lluvia', 'no', `Lluvia de ${num(mmJ)} mm en el horario de trabajo${lluviosas.length ? ` (${rango(lluviosas)})` : ''}`);
    else if (mmJ >= U.lluviaCuidado) add('lluvia', 'cuidado', `Lluvia débil: ${num(mmJ, 1)} mm ${rango(lluviosas)}`);
    else if (probMax != null && probMax >= U.probCuidado) add('lluvia', 'cuidado', `Probabilidad de lluvia de ${Math.round(probMax)} %`);
    if (mmDia - mmJ >= 15) add('barro', 'cuidado', `Llueve fuerte fuera del horario (${num(mmDia - mmJ)} mm): suelo con barro`);
    if (raf != null && raf >= U.rafagaNoApto) add('viento', 'no', `Ráfagas de ${Math.round(raf)} km/h${horaRaf ? ` a las ${horaRaf.h} h` : ''}: no trabajar en altura ni con grúa`);
    else if (raf != null && raf >= U.rafagaCuidado) add('viento', 'cuidado', `Ráfagas de ${Math.round(raf)} km/h${horaRaf ? ` a las ${horaRaf.h} h` : ''}: cuidado en altura y con la grúa`);
    if (tmax != null && tmax >= U.calorNoApto) add('calor', 'no', `Calor extremo (${Math.round(tmax)}°): riesgo de golpe de calor`);
    else if (tmax != null && tmax >= U.calorCuidado) add('calor', 'cuidado', `Calor de ${Math.round(tmax)}°: pausas e hidratación`);
    if (tmin != null && tmin <= U.frioNoApto) add('frio', 'no', `Helada (${Math.round(tmin)}°) en el horario de trabajo`);
    else if (tmin != null && tmin <= U.frioCuidado) add('frio', 'cuidado', `Frío de ${Math.round(tmin)}°: ojo con hormigón y morteros`);
  } else if (d) {
    // Solo dato diario: se supone que la mitad de la lluvia cae en el horario de trabajo
    datos = { mmJ: d.mm / 2, mmDia: d.mm, probMax: d.prob, rafaga: d.rafaga, tmax: d.tmax, tmin: d.tmin, horas: 0, code: d.code, diario: true };
    if (d.code != null && d.code >= 95) add('tormenta', 'no', 'Tormenta eléctrica en el día');
    if (d.mm >= U.lluviaNoApto * 2) add('lluvia', 'no', `Lluvia de ${num(d.mm)} mm en el día`);
    else if (d.mm >= U.lluviaCuidado * 2) add('lluvia', 'cuidado', `Lluvia de ${num(d.mm, 1)} mm en el día`);
    else if (d.prob != null && d.prob >= U.probCuidado) add('lluvia', 'cuidado', `Probabilidad de lluvia de ${Math.round(d.prob)} %`);
    if (d.rafaga != null && d.rafaga >= U.rafagaNoApto) add('viento', 'no', `Ráfagas de ${Math.round(d.rafaga)} km/h`);
    else if (d.rafaga != null && d.rafaga >= U.rafagaCuidado) add('viento', 'cuidado', `Ráfagas de ${Math.round(d.rafaga)} km/h`);
    if (d.tmax != null && d.tmax >= U.calorNoApto) add('calor', 'no', `Calor extremo (${Math.round(d.tmax)}°)`);
    else if (d.tmax != null && d.tmax >= U.calorCuidado) add('calor', 'cuidado', `Calor de ${Math.round(d.tmax)}°`);
    // de madrugada siempre hace más frío que en la jornada: se exige un grado menos
    if (d.tmin != null && d.tmin <= U.frioNoApto - 1) add('frio', 'no', `Helada (${Math.round(d.tmin)}°)`);
    else if (d.tmin != null && d.tmin <= U.frioCuidado - 2) add('frio', 'cuidado', `Frío de ${Math.round(d.tmin)}°`);
  } else {
    return { fecha, estado: null, motivos: [], laborable: U.diasLaborales.includes(diaIso(fecha)), datos: null, resumen: 'Sin datos' };
  }
  motivos.sort((a, b) => ORDEN[b.estado] - ORDEN[a.estado]);
  const estado = motivos.length ? motivos[0].estado : 'apto';
  const resumen = estado === 'apto' ? 'Buen día para trabajar' : motivos[0].texto;
  const tipo = tipoTiempo(datos.code, datos.mmDia, false);
  return { fecha, estado, motivos, laborable: U.diasLaborales.includes(diaIso(fecha)), datos, resumen, tiempo: tipo };
}

// ───────────────────────────────────────────── recomendador de tareas
/*
  Cada tarea: lista de criterios. Cada criterio da ok / no y cuánto resta si no se cumple.
  "duro" = si falla, el día no se recomienda (tope 35 puntos).
  Puntaje = 100 − lo que resta; ≥ 80 ideal, 60-79 posible, < 60 no recomendado.
*/
const TAREAS = {
  hormigonado: { nombre: 'Hormigonado', emoji: '🚛', bajada: 'Llenado de losas, vigas y bases' },
  impermeabilizacion: { nombre: 'Impermeabilización', emoji: '🛡️', bajada: 'Membranas y pinturas asfálticas en techos' },
  pintura: { nombre: 'Pintura exterior', emoji: '🎨', bajada: 'Fachadas, revestimientos y látex exterior' },
  suelos: { nombre: 'Movimiento de suelos', emoji: '🚜', bajada: 'Excavación, relleno y compactación' },
  grua: { nombre: 'Izaje con grúa', emoji: '🏗️', bajada: 'Montaje e izaje de cargas' },
};

function criteriosTarea(tarea, ix, fecha, U) {
  const j0 = tLocal(fecha, U.jornadaDesde), j1 = tLocal(fecha, U.jornadaHasta);
  const jor = horasEntre(ix, j0, j1);
  if (jor.length < 3) return null;
  const antes = (h) => horasEntre(ix, tLocal(fecha, U.jornadaDesde - h), j0);
  const despues = (h) => {
    const fin = new Date(Date.parse(j1 + ':00Z') + h * 3600e3).toISOString().slice(0, 13) + ':00';
    return horasEntre(ix, j1, fin);
  };
  const mmJ = suma(jor), probJ = maxDe(jor, 'prob'), raf = maxDe(jor, 'rafaga'), vmed = maxDe(jor, 'viento');
  const tmax = maxDe(jor, 'temp'), tmin = minDe(jor, 'temp'), humMin = minDe(jor, 'hum'), humMax = maxDe(jor, 'hum');
  const tormenta = jor.some((x) => x.code >= 95);
  const C = [];
  const c = (ok, resta, texto, duro) => C.push({ ok: !!ok, resta: ok ? 0 : resta, texto, duro: !!duro });
  const sinLluviaDia = (mmMax, probMax) => c(mmJ <= mmMax && (probJ == null || probJ <= probMax),
    35, mmJ > mmMax ? `Llueve ${num(mmJ, 1)} mm en el horario de trabajo` : probJ != null && probJ > probMax ? `Probabilidad de lluvia de ${Math.round(probJ)} % en el día` : 'Sin lluvia en el día', mmJ > Math.max(mmMax, U.lluviaCuidado));
  const okTxt = (ok, si, no) => (ok ? si : no);
  const cubreDespues = (h) => despues(h).length >= Math.min(h, 24) * 0.8;

  if (tormenta) c(false, 60, 'Tormenta eléctrica en el horario de trabajo', true);

  if (tarea === 'hormigonado') {
    const a = suma(antes(U.ventanaAntes));
    c(a <= 2, 15, okTxt(a <= 2, `Sin lluvia en las ${U.ventanaAntes} h anteriores`, `Llueven ${num(a)} mm en las ${U.ventanaAntes} h anteriores: base y encofrados mojados`));
    sinLluviaDia(0.5, 40);
    const d12 = suma(despues(12)), dTot = suma(despues(U.ventanaDespues));
    const okD = d12 <= 1 && dTot <= 5;
    c(okD, d12 > 1 ? 30 : 15, okD ? `Sin lluvia en las ${U.ventanaDespues} h siguientes (curado)` : `Lluvia de ${num(dTot)} mm en las ${U.ventanaDespues} h siguientes: puede lavar la superficie`, d12 > 3);
    if (!cubreDespues(U.ventanaDespues)) C.push({ ok: true, resta: 5, texto: 'El pronóstico todavía no cubre todo el curado', aviso: true });
    const tOk = tmin >= U.hormigonTmin && tmax <= U.hormigonTmax;
    c(tOk, 20, tOk ? `Temperatura entre ${Math.round(tmin)}° y ${Math.round(tmax)}°` : tmax > U.hormigonTmax ? `Calor de ${Math.round(tmax)}°: fragua rápida y fisuras` : `Frío de ${Math.round(tmin)}°: fragua lenta`, tmin < U.hormigonTmin - 3);
    const h72 = minDe(despues(72), 'temp');
    c(h72 == null || h72 >= 2, 25, h72 == null || h72 >= 2 ? 'Sin heladas en los 3 días siguientes' : `Helada de ${Math.round(h72)}° en los días de curado`, h72 != null && h72 < 0);
    c(raf == null || raf <= U.hormigonRafaga, 10, raf == null || raf <= U.hormigonRafaga ? `Viento tranquilo (ráfagas de ${Math.round(raf || 0)} km/h)` : `Ráfagas de ${Math.round(raf)} km/h: evaporación rápida y fisuras`);
    if (humMin != null) c(humMin >= 40, 8, humMin >= 40 ? `Humedad adecuada (${Math.round(humMin)} % o más)` : `Aire muy seco (${Math.round(humMin)} %): curar con agua o antisol`);
  } else if (tarea === 'impermeabilizacion') {
    const a = suma(antes(U.ventanaAntes));
    c(a <= 0.5, 25, a <= 0.5 ? `Superficie seca: sin lluvia en las ${U.ventanaAntes} h anteriores` : `Llueven ${num(a)} mm antes: la carpeta va a estar mojada`, a > 3);
    sinLluviaDia(0.2, 30);
    const d24 = suma(despues(24));
    c(d24 <= 1, 20, d24 <= 1 ? 'Sin lluvia en las 24 h siguientes' : `Lluvia de ${num(d24)} mm en las 24 h siguientes`);
    c(tmin >= 5, 20, tmin >= 5 ? `Temperatura de ${Math.round(tmin)}° o más` : `Frío de ${Math.round(tmin)}°: la membrana no adhiere bien`, tmin < 2);
    if (humMax != null) c(humMax <= 85, 10, humMax <= 85 ? 'Humedad por debajo del 85 %' : `Humedad del ${Math.round(humMax)} %: riesgo de condensación`);
    c(raf == null || raf <= 30, 10, raf == null || raf <= 30 ? 'Poco viento para trabajar con soplete' : `Ráfagas de ${Math.round(raf)} km/h: peligroso con soplete y rollos`);
  } else if (tarea === 'pintura') {
    sinLluviaDia(0.2, 30);
    const d12 = suma(despues(12));
    c(d12 <= 0.2, 20, d12 <= 0.2 ? 'Sin lluvia en las 12 h siguientes (secado)' : `Lluvia de ${num(d12, 1)} mm antes de que seque`);
    const tOk = tmin >= 10 && tmax <= 30;
    c(tOk, 20, tOk ? `Temperatura entre ${Math.round(tmin)}° y ${Math.round(tmax)}°` : tmin < 10 ? `Frío de ${Math.round(tmin)}°: la pintura no cura bien` : `Calor de ${Math.round(tmax)}°: seca demasiado rápido`, tmin < 5);
    if (humMax != null) c(humMax <= 85, 15, humMax <= 85 ? 'Humedad por debajo del 85 %' : `Humedad del ${Math.round(humMax)} %`);
    c(raf == null || raf <= 25, 10, raf == null || raf <= 25 ? 'Poco viento' : `Ráfagas de ${Math.round(raf)} km/h: polvo y salpicaduras`);
    const rocio = jor.filter((x) => x.rocio != null && x.temp - x.rocio < 3);
    if (jor.some((x) => x.rocio != null)) c(!rocio.length, 10, !rocio.length ? 'Sin rocío sobre la pared' : `Rocío ${rango(rocio)}: esperar a que seque la pared`);
  } else if (tarea === 'suelos') {
    const a = suma(antes(48));
    c(a <= 10, 30, a <= 10 ? `Suelo trabajable (${num(a)} mm en las 48 h anteriores)` : `Llovieron ${num(a)} mm en las 48 h anteriores: barro y suelo saturado`, a > 25);
    c(mmJ <= 2, 30, mmJ <= 2 ? 'Sin lluvia fuerte en el día' : `Llueve ${num(mmJ)} mm en el horario de trabajo`, mmJ > U.lluviaNoApto);
    c(tmin > 0, 10, tmin > 0 ? 'Sin suelo congelado' : `Helada de ${Math.round(tmin)}°`);
  } else if (tarea === 'grua') {
    const ok = raf == null || raf <= U.gruaRafaga;
    const malas = jor.filter((x) => x.rafaga != null && x.rafaga > U.gruaRafaga);
    c(ok, 45, ok ? `Ráfagas por debajo de ${U.gruaRafaga} km/h (máx. ${Math.round(raf || 0)})` : `Ráfagas de ${Math.round(raf)} km/h ${rango(malas)}`, !ok);
    c(vmed == null || vmed <= 30, 15, vmed == null || vmed <= 30 ? 'Viento medio moderado' : `Viento sostenido de ${Math.round(vmed)} km/h`);
    sinLluviaDia(2, 70);
    const vis = minDe(jor, 'vis');
    if (vis != null) c(vis >= 1000, 15, vis >= 1000 ? 'Buena visibilidad' : `Visibilidad de ${num(vis / 1000, 1)} km (niebla)`, vis < 300);
  }
  return C;
}

/** Puntaje (0-100) y explicación de una tarea para un día. null si no hay pronóstico horario de ese día. */
function evaluarTarea(tarea, ix, fecha, U) {
  U = U || UMBRALES_DEFAULT;
  const C = criteriosTarea(tarea, ix, fecha, U);
  if (!C) return null;
  let p = 100 - C.reduce((a, x) => a + x.resta, 0);
  const duro = C.some((x) => x.duro && !x.ok);
  if (duro) p = Math.min(p, 35);
  else if (C.some((x) => !x.ok)) p = Math.min(p, 79); // "ideal" solo si se cumple todo
  p = Math.max(0, Math.min(100, Math.round(p)));
  const nivel = p >= 80 ? 'ideal' : p >= 60 ? 'posible' : 'no';
  const fallas = C.filter((x) => !x.ok);
  const explicacion = nivel === 'ideal'
    ? `Buen día para ${TAREAS[tarea].nombre.toLowerCase()}: ${C.filter((x) => x.ok).slice(0, 2).map((x) => x.texto.charAt(0).toLowerCase() + x.texto.slice(1)).join(' y ')}.`
    : fallas.length ? `${fallas[0].texto}.` : 'Se puede, con algunos cuidados.';
  return { tarea, fecha, puntaje: p, nivel, criterios: C, explicacion, laborable: U.diasLaborales.includes(diaIso(fecha)) };
}

/** Mejores días para una tarea en las fechas pedidas (solo días laborables con pronóstico horario). */
function mejoresDias(tarea, ix, fechas, U, n = 3) {
  return fechas.map((f) => evaluarTarea(tarea, ix, f, U)).filter((x) => x && x.laborable)
    .sort((a, b) => b.puntaje - a.puntaje || (a.fecha < b.fecha ? -1 : 1)).slice(0, n);
}

/** Qué tan confiable es el pronóstico según cuántos días faltan. */
const confianza = (diasAdelante) => (diasAdelante <= 3 ? 'alta' : diasAdelante <= 7 ? 'media' : 'baja');

// ───────────────────────────────────────────── climatología (lo que suele pasar en esa época)
/**
 * dias: datos diarios de varios años ({fecha, mm, rafaga, tmax, tmin, code}). Devuelve un Map 'MM-DD' →
 * { pLluvia (≥1 mm), pNoApto, pCuidado, mmMedio, n } con una ventana de ±3 días para suavizar.
 */
function climatologia(dias, U) {
  U = U || UMBRALES_DEFAULT;
  const ixD = { porFecha: new Map(), diasMap: new Map() };
  const porMd = new Map();
  dias.forEach((d) => {
    ixD.diasMap.set(d.fecha, d);
    const md = d.fecha.slice(5);
    if (!porMd.has(md)) porMd.set(md, []);
    porMd.get(md).push(d);
  });
  const evalCache = new Map();
  const ev = (d) => { if (!evalCache.has(d.fecha)) evalCache.set(d.fecha, evaluarDia(ixD, d.fecha, U).estado); return evalCache.get(d.fecha); };
  const out = new Map();
  for (let m = 1; m <= 12; m++) {
    const ultimo = new Date(Date.UTC(2024, m, 0)).getUTCDate();
    for (let dd = 1; dd <= ultimo; dd++) {
      const base = `2024-${pad(m)}-${pad(dd)}`;
      const muestra = [];
      for (let k = -3; k <= 3; k++) { const md = addDias(base, k).slice(5); (porMd.get(md) || []).forEach((x) => muestra.push(x)); }
      if (!muestra.length) continue;
      const n = muestra.length;
      const est = muestra.map(ev);
      out.set(base.slice(5), {
        n,
        pLluvia: muestra.filter((x) => x.mm >= 1).length / n,
        pNoApto: est.filter((e) => e === 'no').length / n,
        pCuidado: est.filter((e) => e === 'cuidado').length / n,
        mmMedio: muestra.reduce((a, x) => a + x.mm, 0) / n,
      });
    }
  }
  return out;
}

/** Promedio histórico de un mes: días de lluvia y días no aptos (hábiles), por año. */
function promedioMes(dias, mes, U) {
  U = U || UMBRALES_DEFAULT;
  const ixD = { porFecha: new Map(), diasMap: new Map(dias.map((d) => [d.fecha, d])) };
  const porAnio = new Map();
  dias.filter((d) => Number(d.fecha.slice(5, 7)) === mes).forEach((d) => {
    const y = d.fecha.slice(0, 4);
    if (!porAnio.has(y)) porAnio.set(y, { lluvia: 0, noApto: 0, habiles: 0, mm: 0, n: 0 });
    const a = porAnio.get(y);
    a.n += 1; a.mm += d.mm;
    if (d.mm >= 1) a.lluvia += 1;
    if (U.diasLaborales.includes(diaIso(d.fecha))) {
      a.habiles += 1;
      if (evaluarDia(ixD, d.fecha, U).estado === 'no') a.noApto += 1;
    }
  });
  const anios = [...porAnio.values()].filter((a) => a.n >= 25);
  if (!anios.length) return null;
  const prom = (k) => anios.reduce((s, a) => s + a[k], 0) / anios.length;
  return { anios: anios.length, diasLluvia: prom('lluvia'), noAptoHabiles: prom('noApto'), mm: prom('mm'), habiles: prom('habiles') };
}

// ───────────────────────────────────────────── resumen de un período (historial, reporte)
function resumenPeriodo(evals, U) {
  U = U || UMBRALES_DEFAULT;
  const conDatos = evals.filter((e) => e && e.estado);
  const hab = conDatos.filter((e) => e.laborable);
  const mm = conDatos.reduce((a, e) => a + (e.datos.mmDia || 0), 0);
  const porMotivo = {};
  hab.filter((e) => e.estado === 'no').forEach((e) => e.motivos.filter((m) => m.estado === 'no').forEach((m) => { porMotivo[m.tipo] = (porMotivo[m.tipo] || 0) + 1; }));
  return {
    dias: conDatos.length,
    habiles: hab.length,
    aptos: hab.filter((e) => e.estado === 'apto').length,
    cuidado: hab.filter((e) => e.estado === 'cuidado').length,
    noAptos: hab.filter((e) => e.estado === 'no').length,
    noAptosLluvia: hab.filter((e) => e.estado === 'no' && e.motivos.some((m) => m.estado === 'no' && (m.tipo === 'lluvia' || m.tipo === 'tormenta'))).length,
    diasLluvia: conDatos.filter((e) => (e.datos.mmDia || 0) >= 1).length,
    mm,
    mmMax: conDatos.reduce((a, e) => Math.max(a, e.datos.mmDia || 0), 0),
    rafagaMax: conDatos.reduce((a, e) => Math.max(a, e.datos.rafaga || 0), 0),
    tmax: conDatos.reduce((a, e) => (e.datos.tmaxDia != null || e.datos.tmax != null ? Math.max(a, e.datos.tmaxDia != null ? e.datos.tmaxDia : e.datos.tmax) : a), -99),
    tmin: conDatos.reduce((a, e) => (e.datos.tminDia != null || e.datos.tmin != null ? Math.min(a, e.datos.tminDia != null ? e.datos.tminDia : e.datos.tmin) : a), 99),
    porMotivo,
  };
}

// ───────────────────────────────────────────── avisos (los manda el motor del Editor)
const AVISOS_DEFAULT = {
  lluvia_manana: { activo: false, mm: 2 },
  lluvia_fuerte: { activo: false, horas: 3, mm: 4 },
  lluvia_ahora: { activo: false },
  viento: { activo: false, kmh: 40 },
  temperatura: { activo: false, max: 35, min: 0 },
  tormenta: { activo: false },
  hormigonado: { activo: false },
  resumen_semanal: { activo: false, hora: '08:00' },
  camara_lluvia: { activo: false }, // experimental: ver lluviaEnFoto
};
const URGENTES = new Set(['tormenta']);
const FRANJA = { desde: 8, hasta: 20 }; // regla del bot: nada fuera de 8-20 h…
const FRANJA_URGENTE = { desde: 6, hasta: 23 }; // …salvo las urgentes (tormenta)
const HORA_TARDE = 17; // los avisos "de mañana" salen desde las 17 h

/**
 * Qué avisos corresponden AHORA para una obra. No manda nada ni deduplica: devuelve
 * [{tipo, clave, urgente, titulo, texto}]; `clave` sirve para no repetir (alertLog).
 *   pron: desdeOpenMeteo(forecast con current + minutely_15 + hourly + daily)
 *   C: avisos de la obra (alertConfigs.obras[].alertas.clima); U: umbrales; ahoraMs: Date.now()
 *   extra.camaraMojada: resultado de lluviaEnFoto (opcional, experimental)
 *   extra.ignorarFranja: true para mostrar en pantalla lo que viene aunque sea de noche (el motor nunca lo usa)
 */
function avisosClima(pron, C, U, ahoraMs, extra) {
  U = U || UMBRALES_DEFAULT;
  C = Object.assign({}, AVISOS_DEFAULT, C || {});
  const ix = pron.porFecha ? pron : indexar(pron);
  const ahora = localDe(ahoraMs, ix.offset);
  const hoy = ahora.slice(0, 10), h = Number(ahora.slice(11, 13));
  const tAhora = ahora.slice(0, 13) + ':00';
  const manana = addDias(hoy, 1);
  const enFranja = h >= FRANJA.desde && h < FRANJA.hasta;
  const enFranjaUrg = h >= FRANJA_URGENTE.desde && h < FRANJA_URGENTE.hasta;
  const out = [];
  const add = (tipo, clave, titulo, texto) => {
    const urgente = URGENTES.has(tipo);
    if (!(extra && extra.ignorarFranja) && (urgente ? !enFranjaUrg : !enFranja)) return;
    out.push({ tipo, clave: `clima_${tipo}_${clave}`, urgente, titulo, texto });
  };
  const prox = (n) => horasEntre(ix, tAhora, new Date(Date.parse(tAhora + ':00Z') + n * 3600e3).toISOString().slice(0, 13) + ':00');
  const bloque = (t) => `${t.slice(0, 10)}_${Math.floor(horaDe(t) / 6)}`; // un aviso por franja de 6 h

  if (C.tormenta && C.tormenta.activo) {
    const ts = prox(3).filter((x) => x.code >= 95);
    if (ts.length) add('tormenta', bloque(ts[0].t), '⛈️ Tormenta eléctrica', `Se viene una tormenta eléctrica ${ts[0].fecha === hoy ? 'hoy' : 'mañana'} ${rango(ts)}. Bajen de altura, aseguren la grúa y el material suelto.`);
  }
  if (C.lluvia_fuerte && C.lluvia_fuerte.activo) {
    const n = Math.min(12, Math.max(1, C.lluvia_fuerte.horas || 3)), mm = C.lluvia_fuerte.mm || 4;
    const fuertes = prox(n).filter((x) => x.mm >= mm);
    if (fuertes.length) {
      const pico = fuertes.reduce((a, x) => (x.mm > a.mm ? x : a));
      add('lluvia_fuerte', bloque(fuertes[0].t), '🌧️ Lluvia fuerte', `Lluvia fuerte en las próximas ${n} h: hasta ${num(pico.mm)} mm por hora a las ${pico.h} h. Cubran material y protejan lo recién hecho.`);
    }
  }
  if (C.lluvia_ahora && C.lluvia_ahora.activo) {
    const ult = (ix.m15 || []).filter((x) => x.t <= ahora && x.t > new Date(Date.parse(ahora + ':00Z') - 30 * 60e3).toISOString().slice(0, 16));
    const mm30 = ult.reduce((a, x) => a + x.mm, 0);
    const act = ix.actual && ix.actual.precipitation != null ? ix.actual.precipitation : 0;
    const medido = Math.max(mm30, act);
    const camara = extra && extra.camaraMojada && extra.camaraMojada.probable && C.camara_lluvia && C.camara_lluvia.activo;
    if (medido >= 0.3 || (camara && medido > 0)) {
      add('lluvia_ahora', bloque(tAhora), '☔ Está lloviendo en la obra', `Está lloviendo en la obra ahora (${num(medido, 1)} mm en la última media hora${camara ? ', y la cámara muestra la lente mojada' : ''}).`);
    }
  }
  if (C.viento && C.viento.activo) {
    const kmh = C.viento.kmh || U.gruaRafaga;
    const malas = prox(6).filter((x) => x.h >= U.jornadaDesde && x.h < U.jornadaHasta && x.rafaga != null && x.rafaga >= kmh);
    if (malas.length) {
      const pico = malas.reduce((a, x) => (x.rafaga > a.rafaga ? x : a));
      add('viento', hoy, '💨 Viento fuerte', `Ráfagas de ${Math.round(pico.rafaga)} km/h a las ${pico.h} h. Si hay izajes con grúa o trabajos en altura, conviene reprogramarlos.`);
    }
  }
  const mananaLaborable = U.diasLaborales.includes(diaIso(manana));
  if (h >= HORA_TARDE && mananaLaborable) {
    const eM = evaluarDia(ix, manana, U);
    if (C.lluvia_manana && C.lluvia_manana.activo && eM.datos && !eM.datos.diario) {
      const mm = C.lluvia_manana.mm || 2;
      const jor = (ix.porFecha.get(manana) || []).filter((x) => x.h >= U.jornadaDesde && x.h < U.jornadaHasta);
      const lluv = jor.filter((x) => x.mm >= 0.2);
      const prob = eM.datos.probMax;
      if (eM.datos.mmJ >= mm || (prob != null && prob >= 70 && eM.datos.mmJ >= 0.5)) {
        add('lluvia_manana', manana, '🌧️ Mañana llueve', `Mañana ${fechaLarga(manana)} se esperan ${num(eM.datos.mmJ)} mm ${rango(lluv)}${prob != null ? ` (probabilidad ${Math.round(prob)} %)` : ''}. Planificá tareas bajo techo.`);
      }
    }
    if (C.temperatura && C.temperatura.activo && eM.datos) {
      const max = C.temperatura.max != null ? C.temperatura.max : U.calorNoApto, min = C.temperatura.min != null ? C.temperatura.min : U.frioNoApto;
      const tmax = eM.datos.tmaxDia != null ? eM.datos.tmaxDia : eM.datos.tmax, tmin = eM.datos.tminDia != null ? eM.datos.tminDia : eM.datos.tmin;
      if (tmax != null && tmax >= max) add('temperatura', manana + '_calor', '🥵 Calor extremo mañana', `Mañana llega a ${Math.round(tmax)}°. Arranquen temprano, pausas a la sombra y mucha agua. Evitar hormigonar al mediodía.`);
      else if (tmin != null && tmin <= min) add('temperatura', manana + '_frio', '🥶 Helada mañana', `Mañana a la mañana baja a ${Math.round(tmin)}°. Protejan el hormigón fresco y los morteros; cuidado con superficies congeladas.`);
    }
    if (C.hormigonado && C.hormigonado.activo) {
      const t = evaluarTarea('hormigonado', ix, manana, U);
      if (t && t.nivel === 'ideal') add('hormigonado', manana, '🚛 Buen día para hormigonar', `Mañana ${fechaLarga(manana)} es un buen día para hormigonar (${t.puntaje}/100): ${t.criterios.filter((x) => x.ok).slice(0, 3).map((x) => x.texto.toLowerCase()).join(', ')}.`);
    }
  }
  if (C.resumen_semanal && C.resumen_semanal.activo && diaIso(hoy) === 1) {
    const hh = Number(String(C.resumen_semanal.hora || '08:00').slice(0, 2));
    if (h >= hh) {
      const dias = [0, 1, 2, 3, 4, 5, 6].map((k) => addDias(hoy, k)).filter((f) => U.diasLaborales.includes(diaIso(f)));
      const ev = dias.map((f) => evaluarDia(ix, f, U)).filter((e) => e.estado);
      if (ev.length) {
        const ic = { apto: '✅', cuidado: '⚠️', no: '⛔' };
        const lineas = ev.map((e) => `${ic[e.estado]} ${fechaCorta(e.fecha)}: ${e.estado === 'apto' ? 'apto' : e.motivos[0].texto.toLowerCase()}`);
        const aptos = ev.filter((e) => e.estado === 'apto').length;
        add('resumen_semanal', hoy, '📅 El clima de la semana', `Esta semana hay ${aptos} de ${ev.length} días aptos para trabajar:\n${lineas.join('\n')}`);
      }
    }
  }
  return out;
}

// ───────────────────────────────────────────── "lluvia en la cámara" (EXPERIMENTAL, apagado por defecto)
/*
  Heurística liviana, sin IA paga: cuando llueve, las gotas en la lente y el aire cargado bajan la nitidez
  (varianza del Laplaciano) y el contraste de la foto. Se compara la foto actual contra fotos de la misma
  cámara en horas secas parecidas (referencia = mediana). La calcula quien tiene la imagen (canvas en el
  navegador, sharp en el Editor) SOLO con fotos que la cámara ya subió: nunca se le pide una foto a la cámara.
  Falla con niebla, de noche, con la lente sucia o si alguien movió la cámara: por eso es experimental,
  va apagada y solo suma cuando el servicio meteorológico también marca lluvia.
*/
function lluviaEnFoto(actual, referencias) {
  const refs = (referencias || []).filter((r) => r && r.nitidez > 0);
  if (!actual || !(actual.nitidez > 0) || refs.length < 3) return { probable: false, confiable: false, score: 0, texto: 'Faltan fotos de referencia' };
  const med = (k) => { const v = refs.map((r) => r[k]).sort((a, b) => a - b); return v[Math.floor(v.length / 2)]; };
  const caidaNit = 1 - actual.nitidez / med('nitidez');
  const caidaCon = 1 - actual.contraste / med('contraste');
  const oscura = actual.brillo < 35;
  const score = Math.max(0, Math.min(1, caidaNit * 0.7 + caidaCon * 0.3));
  const probable = !oscura && caidaNit >= 0.45 && caidaCon >= 0.15;
  return { probable, confiable: !oscura, score: Math.round(score * 100) / 100, texto: oscura ? 'Foto muy oscura: no se puede saber' : probable ? 'La foto se ve borrosa como con lluvia o la lente mojada' : 'La foto se ve normal' };
}

// ───────────────────────────────────────────── config de clima de la cámara (climaConfigs/{feedId})
function sanearReporte(x, base) {
  const b = Object.assign({ activo: false, dia: 1, emails: [], logo: true }, base || {});
  const r = x && typeof x === 'object' ? x : {};
  const emails = Array.isArray(r.emails) ? r.emails : b.emails;
  return {
    activo: typeof r.activo === 'boolean' ? r.activo : b.activo,
    dia: Number.isFinite(Number(r.dia)) ? Math.min(28, Math.max(1, Math.round(Number(r.dia)))) : b.dia,
    emails: Array.from(new Set(emails.map((e) => String(e || '').trim().toLowerCase()).filter((e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)))).slice(0, 10),
    logo: typeof r.logo === 'boolean' ? r.logo : b.logo,
  };
}

export default {
  UMBRALES_DEFAULT, LIMITES, AVISOS_DEFAULT, TAREAS, ESTADO_TXT, TIEMPO_TXT, FRANJA, FRANJA_URGENTE,
  sanearUmbrales, sanearReporte, desdeOpenMeteo, indexar, evaluarDia, evaluarTarea, mejoresDias, confianza,
  climatologia, promedioMes, resumenPeriodo, avisosClima, lluviaEnFoto, tipoTiempo, direccionTxt,
  addDias, diaIso, fechaLarga, fechaCorta, localDe, num, mayuscula,
};
